/**
 * @Author: Daniel Rhees <Daniel>
 * @Date:   2017-04-06T09:02:52-07:00
 * @Email:  daniel@reflexmedia.com
 * @Last modified by:   Daniel
 * @Last modified time: 2017-04-17T15:33:08-07:00
 */



import React, { Component } from 'react';
import { css, StyleSheet } from 'aphrodite';
import { spacing, dimensions, color, leading } from '../../../style';

const style = StyleSheet.create({

    root: {
      ...spacing.MARGIN_BOTTOM_LG
    },

    title: {
      borderBottom: '1px solid #ebebeb',
      paddingBottom: '8px',
      marginBottom: '14px',
      fontWeight: '600',
      fontSize: '16px',

      [dimensions.SCREEN_MAX_MD]: {
        paddingLeft: '8px',
        marginBottom: '0'
      }
    },

    detailsItem: {
      display: 'flex',
      justifyContent: 'space-between',
      padding: '8px 0',
      margin: '0', // remove margins added in chrome browser

      [dimensions.SCREEN_MAX_MD]: {
        borderBottom: '1px solid #ebebeb',
        padding: '14px 10px'
      }
    },

    infoContainer: {
      ...spacing.PADDING_TOP_SM,
      ...spacing.MARGIN_BOTTOM_LG
    },

    info: {
      fontSize: '14px',
      ...leading.LOOSE,
      ...spacing.PADDING_RIGHT_SM
    }
})

class MoreInfo extends Component {

  render() {

    let profile = this.props.profile;

    return (
      <div className={css(style.root)}>
        <div className={css(style.title)}>Interested In {this.props.profile.username}</div>
        <div className={css(style.infoContainer)}>
          {profile.dating_just_dating && <span className={css(style.info)}>Dating</span>}
          {profile.dating_friendship && <span className={css(style.info)}>Friendship</span>}
          {profile.dating_marriage && <span className={css(style.info)}>Long term relationship</span>}
          {profile.dating_sugar && <span className={css(style.info)}>Travel partner</span>}
          {profile.dating_married && <span className={css(style.info)}>Discreet affairs</span>}
          {profile.dating_adult && <span className={css(style.info)}>Casual dating</span>}</div>
      </div>
    );
  }
}

export default MoreInfo;



// WEBPACK FOOTER //
// ./src/components/pages/Profile/InterestedIn.jsx